import { sceneArchives } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function SceneSection() {
  return (
    <section id="changjing" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          en="Scene Archives"
          title="场景档案 · 把瓜吃明白"
          desc="从事件全貌到鉴别方法再到舆论风向，深度长文带你跳出碎片，看清完整脉络。"
          actionLabel="想了解投稿与核验流程"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {sceneArchives.map((card, idx) => (
            <article
              key={card.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
            >
              <a href="#zhuizong" className="relative block overflow-hidden">
                <div className="aspect-[10/7] overflow-hidden">
                  <img
                    src={card.image}
                    alt={`${card.category}主题深度文章封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span className="absolute top-3 left-3 inline-flex items-center rounded-full bg-background-950/60 px-2.5 py-1 text-xs font-medium whitespace-nowrap text-background-50 backdrop-blur">
                  {card.badge}
                </span>
                <span className="absolute top-3 right-3 font-label flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-sm font-bold text-background-50">
                  0{idx + 1}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
                    <i className="ri-book-open-line" />
                    {card.tag}
                  </span>
                  <span>{card.category}</span>
                  <span className="ml-auto inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line" />
                    {card.views}
                  </span>
                </div>
                <a href="#zhuizong">
                  <h3 className="font-heading mt-3 text-lg leading-snug font-bold text-foreground-950 transition-colors group-hover:text-accent-800">
                    {card.title}
                  </h3>
                </a>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{card.author}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium whitespace-nowrap text-accent-700 group-hover:text-accent-600">
                    查看全文
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}